/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import './style/dashboardKpi.scss';

import React from 'react';

import {useTranslation} from 'react-i18next';

import {BolmateStatCard} from '../../controls';

import {DotsLoader} from '../../controls/loader/dotsLoader';

import {StatCardData} from '../../../util/interfaces';

interface Props {
    cards: Array<Array<StatCardData> | StatCardData>;
    loading: boolean;
    error: boolean;
    comparisonLabel: string;
    hideComparison: boolean;
}

export default function DashboardKpi({cards, loading, error, comparisonLabel, hideComparison}: Props) {
    const {t} = useTranslation();

    // The three stat blocks resolve independently, so the loader only stands in
    // until the first cards arrive — after that the slower blocks fill in
    // around the ones already on screen instead of blanking the grid.
    if (loading && !cards.length) return <DotsLoader dotSize='1.5rem' className='dashboard-kpi-loader' />;

    if (error)
        return (
            <div className='dashboard-kpi-error'>
                {t('overview.kpi.error', 'De statistieken konden niet geladen worden')}
            </div>
        );

    return (
        <div className='dashboard-kpi-grid'>
            {cards.map((card, index: number) => (
                <BolmateStatCard
                    key={index}
                    data={card}
                    comparisonLabel={comparisonLabel}
                    hideComparison={hideComparison}
                />
            ))}
        </div>
    );
}
